import Vue from "vue";
import Vuex from "vuex";
import portal from "./modules/portal";
import clip from "./modules/clip";
import actionsBtns from "./modules/actionsBtns";
import actionsBtnsPanels from "./modules/actionsBtnsPanels"
import Admin from "./modules/admin";
import Settings from "./modules/settings"
import report from "./modules/report";
import game from "./modules/game";
import Menu from "@/store/modules/menu";
import user from "@/store/modules/user";
import panel from "@/store/modules/panel";
import createPersistedState from 'vuex-persistedstate';
import integration from "@/store/modules/integration";

Vue.use(Vuex);
/* eslint-disable no-new */
const store = new Vuex.Store({
  modules: {
    Menu: Menu,
    Admin: Admin,
    Settings: Settings,
    portal: portal,
    clip: clip,
    actionsBtns: actionsBtns,
    actionsBtnsPanels: actionsBtnsPanels,
    user: user,
    panel: panel,
    report: report,
    game: game,
    integration: integration
  },
  state: {
    app: {
      version: "1.0"
    },
    FirebaseFunctionsURL: "https://us-central1-addclarity-b2570.cloudfunctions.net/"
  },
  plugins: [createPersistedState()]
});

export default store;
